import { Close } from '@mui/icons-material';
import { Box, Dialog, IconButton, Stack, Typography } from '@mui/material';

/**
 * Compact list dialog used by the "View all" affordances (ResMan ledger,
 * work orders). Scrollable body, small fixed width.
 */
export default function ViewAllDialog({ open, onClose, title, header, children, maxWidth = 424 }) {
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { maxWidth, width: '100%' } }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2.5, pt: 2, pb: 1 }}>
        <Typography variant="h4" sx={{ fontSize: 15 }}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <Close fontSize="small" />
        </IconButton>
      </Stack>
      {header && <Box sx={{ px: 2.5 }}>{header}</Box>}
      <Box sx={{ px: 2.5, pb: 2.5, overflowY: 'auto', maxHeight: '65vh' }}>{children}</Box>
    </Dialog>
  );
}
